



















import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from './Icon.vue'
// @ts-ignore
import Teleport from 'vue2-teleport'
const vueCustomScrollbar = require('vue-custom-scrollbar')

@Component({
  props: {
    outerClose: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'medium'
    },
    modalCenter: {
      default: false
    },
    closeIcon: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Icon,
    vueCustomScrollbar,
    Teleport
  }
})
export default class Modal extends Vue {
  scrollSettings: any = {
    maxScrollbarLength: 60
  }

  scrollOffset: number = 0

  mounted () {
    this.scrollOffset = window.scrollY
    document.body.style.top = `-${window.scrollY}px`
    document.body.classList.add('modal-opened')
    if (this.$props.outerClose) {
      window.addEventListener('keyup', this.onEsc)
    }
  }

  beforeDestroy () {
    window.document.body.classList.remove('modal-opened')
    document.body.style.top = '0'
    window.scrollTo({ top: this.scrollOffset })
    if (this.$props.outerClose) {
      window.removeEventListener('keyup', this.onEsc)
    }
  }

  onEsc (e: KeyboardEvent) {
    if (e.key === 'Escape') {
      this.$emit('close')
    }
  }

  handleOuterClick () {
    if (this.$props.outerClose) {
      this.$emit('close')
    }
  }
}
